import { Swiper, Pagination}  from 'swiper';


export const imageGrid = () => {

	let imageGridModules = document.querySelectorAll('.m__igrid');
	if(imageGridModules){
		
		require("fslightbox");


		imageGridModules.forEach((imageGridModule) => {
			if(window.innerWidth < 992){
				const igSwiper = new Swiper(imageGridModule.querySelector('.m__igrid__mobile .swiper'), {
					modules: [Pagination],
					centeredSlides : true,
					slidesPerView : 1,
					rewind : true,
					loop: false,
					keyboard: {
						enabled: true,
						onlyInViewport: true,
					},
					pagination: {
				   		el: '.swiper-pagination',
				 	},
				});
			}
		})
		
	}
}
